<template>
  <div class="buyer-container">
    <div class="form-container">
      <form v-scroll-to-error @submit.prevent="submitForm">
        <div v-if="fields.length">
          <v-layout coumn>
            <select-field
              v-model="form.membershipPlanId"
              :validator="$v.form.membershipPlanId"
              :items="membershipPlans"
              item-render="name"
              item-select="id"
              label="Membership type"
              class="flex-2 pb-2"
              box
            />
          </v-layout>
          <v-layout :column="$vuetify.breakpoint.xs">
            <v-flex v-if="fields[0].component === 'avatar-field'" shrink class="mr-16">
              <v-flex v-for="field in firstField" :key="field.key">
                <component
                  :is="field.component"
                  v-model="form[field.key]"
                  :validator="$v && $v.form[field.key]"
                  v-bind="field"
                />
              </v-flex>
            </v-flex>
            <v-flex>
              <v-layout column>
                <v-flex v-for="field in firstThreeFields" :key="field.key" class="pb-16">
                  <component
                    :is="field.component"
                    v-model="form[field.key]"
                    :validator="$v && $v.form[field.key]"
                    v-bind="field"
                    :error-messages="field.errorMessages"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout column>
            <v-flex v-for="field in otherFields" :key="field.key" class="pb-16">
              <component
                :is="field.component"
                v-model="form[field.key]"
                :validator="$v && $v.form[field.key]"
                v-bind="field"
                :error-messages="field.errorMessages"
              />
            </v-flex>
          </v-layout>

          <!--          <v-divider class="pb-2" />-->
          <!--          <div>-->
          <!--            <h2 class="subs-title">Fizicke komponente</h2>-->
          <!--          </div>-->
        </div>

        <v-layout row align-center justify-space-between>
          <main-button outline type="button" color="red" @click="$router.go(-1)">
            Cancel
          </main-button>
          <main-button :disabled="submitting" type="submit">
            {{ initialValues ? 'Update' : 'Save' }}
          </main-button>
        </v-layout>
      </form>
    </div>
  </div>
</template>
<script>
import { GET_ORGANIZATION_MEMBERSHIP_PLANS } from '@/graphql/membershipPlan.graphql'
import { required } from 'vuelidate/lib/validators'
import { EventBus } from '@/plugins/event-bus'

export default {
  name: 'member-form',
  props: {
    organizationSlug: {
      type: String,
    },
    initialValues: {
      type: Object,
      default: () => null,
    },
    schema: {
      type: Object,
      default: () => {},
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      membershipPlans: [],
      fields: [],
      form: {
        membershipPlanId: null,
      },
    }
  },
  computed: {
    firstField() {
      return this.fields.slice(0, 1)
    },
    firstThreeFields() {
      if (this.fields[0].component === 'avatar-field') {
        return this.fields.slice(1, 4)
      } else {
        return this.fields.slice(0, 4)
      }
    },
    otherFields() {
      return this.fields.slice(4)
    },
  },
  async mounted() {
    await this.fetchMembershipPlans()
    this.setFields()
    if (this.initialValues) {
      this.setFormData()
    }
  },
  validations() {
    return {
      form: {
        membershipPlanId: { required },
        ...this.schema.validationSchema,
      },
    }
  },
  methods: {
    setFields() {
      this.fields = this.schema.attendeeFields
    },
    setFormData() {
      this.form = {
        membershipPlanId: this.initialValues.membershipPlanId,
        ...this.initialValues.fields,
      }
    },
    async fetchMembershipPlans() {
      const { data, errors } = await this.$apollo.query({
        query: GET_ORGANIZATION_MEMBERSHIP_PLANS,
        variables: {
          organizationSlug: this.organizationSlug,
        },
      })
      if (errors) {
        EventBus.$emit('toggle-snackbar', {
          title: 'Error',
          message: 'Oops, Something went wrong!',
          type: 'error',
        })
      } else {
        this.membershipPlans = data.getOrganizationMembershipPlans
      }
    },
    submitForm() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return false
      }

      this.$emit(this.initialValues ? 'onUpdate' : 'onCreate', this.form)
    },
  },
}
</script>
<style scoped>
.flex-2 {
  flex: 2;
}

.subs-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
  margin-bottom: 1.5rem;
}
</style>
